<template>
  <div class="frontend w-100 d-flex justify-content-center align-items-center vh-100">
    <div
      v-show="$store.state.appConfig.showLoader"
      class="axios-loader"
    >
      <loader />
    </div>
    <!-- <div
        id="user-info-container"
        class="text-white"
      >
        {{ singpassUserInfo }}
      </div> -->
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loader from './Loader.vue'

export default {
  components: {
    Loader,
  },
  data() {
    return {}
  },
  mounted() {
    const formData = new FormData()
    formData.append('fileID', this.$route.params.id)

    this.$http.post('front-end/files/certificate/download', formData, {
      headers: { Accept: 'application/pdf' },
      responseType: 'arraybuffer',
    })
      .then(response => {
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'Notice of Full Payment.pdf'

        if (contentDisposition) {
          const filenameRegex = /filename\*?=(?:UTF-8''|)([^;\n]*)/i
          const matches = filenameRegex.exec(contentDisposition)
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''))
          }
        }

        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
}
</script>

<style lang="scss">
  ._hj-widget-container {
    display: none !important;
  }
</style>
